<template>
  <el-container class="ScheduleForm">
    <el-main class="p-0">
      <el-form
        ref="form"
        label-width="80px"
        class="form-label-80"
        :model="data"
        :rules="rules"
        inline
      >
        <el-row>
          <el-col :span="7">
            <el-form-item label="거래처" prop="customer_name">
              <ACustomerSelector
                v-model="data.customer_name"
                allowUnselected
                @select="handleSelectCustomer"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="우편번호" prop="zipcode">
              <el-input
                v-model="data.zipcode"
                class="zipcode readonly"
                readonly
              />
              &nbsp;
              <el-button @click="popupZipcode(handleCompleteZipcode)"
                >우편번호검색</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="주소" prop="addr">
              <el-input ref="addr" v-model="data.addr" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="연락처" prop="tel">
              <el-input v-model="data.tel" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="납기일" prop="schedule_date">
              <ADatePicker v-model="data.schedule_date" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="담당자" prop="charger">
              <el-input v-model="data.charger" />
            </el-form-item>
          </el-col>
          <el-col :span="6" v-show="!data.uid.startsWith('service')">
            <el-form-item label="출하방법" prop="delivery_way_flag">
              <ADeliveryWaySelector
                v-model="data.delivery_way_flag"
                @change="handleChangeDeliveryWay"
                style="width: 150px;"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="처리내용" prop="task">
              <el-input v-model="data.task" :disabled="!isSchedule" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="현장" prop="field">
              <el-input v-model="data.field" :disabled="!isContract" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="비고" prop="desc">
              <el-input v-model="data.desc" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="!has_grant_write"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{
          isNew ? $t("button.register") : $t("button.modify")
        }}
        (F4)</el-button
      >
      <el-button
        type="danger"
        v-if="isSchedule && !isNew"
        :disabled="!has_grant_write"
        @click="handleClickDelete"
        >삭 제</el-button
      >
      <el-button class="close-button" @click="closeDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
import { form } from "@/common/mixins/form";
import { zipcode_search } from "@/common/mixins/zipcode_search";
export default {
  name: "ScheduleForm",
  mixins: [form, zipcode_search],
  data() {
    var validateZipcode = (rule, value, callback) => {
      if (["1", "2", "4", "11", "12"].includes(this.data.delivery_way_flag)) {
        if (!value) {
          callback(new Error("우편번호를 입력해 주세요."));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      title: this.$t("title.integrated_schedule"),
      rules: {
        customer_name: [{ required: true, message: "거래처를 선택해 주세요." }],
        zipcode: [{ validator: validateZipcode }],
        addr: [{ required: true, message: "주소를 입력해 주세요." }],
        schedule_date: [{ required: true, message: "일자를 선택해 주세요." }],
        task: [{ required: true, message: "처리내용을 입력해 주세요." }],
      },
      customer: null,
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          uid: "schedule_0",
          customer_id: null,
          customer_name: "",
          zipcode: null,
          addr: "",
          tel: "",
          schedule_date: null,
          delivery_way_flag: "",
          charger: "",
          task: "",
          field: "",
          desc: "",
        };
      },
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isNew() {
      return this.data.id < 1;
    },
    isSchedule() {
      return this.data.uid.startsWith("schedule");
    },
    isContract() {
      return (
        this.data.uid.startsWith("contract") ||
        this.data.uid.startsWith("assemble")
      );
    },
    deliveryWayFlagOption() {
      return this.system.options.delivery_way_flag;
    },
  },
  methods: {
    doRegister() {
      let data = Object.assign({}, this.data);
      let api = this.api.createSchedule;
      if (this.isContract) {
        data = this.convertToContractData(data);
        api = this.api.updateContractDetail;
      } else if (this.data.uid.startsWith("service")) {
        data = this.convertToServiceData(data);
        api = this.api.updateService;
      } else if (!this.isNew) {
        api = this.api.updateSchedule;
      }
      api(data).then((res) => {
        let message = this.isNew
          ? this.$t("message.success_create")
          : this.$t("message.success_update");
        this.handleReponse(res, message);
      });
    },
    doDelete() {
      this.api.deleteSchedule(this.data).then((res) => {
        this.handleReponse(res, this.$t("message.success_delete"));
      });
    },
    convertToContractData(data) {
      data.customer_tel = data.tel;

      data.detail_zipcode = data.zipcode;
      data.zipcode = data.contract_zipcode;

      data.detail_destination = data.addr;
      data.destination = data.contract_addr;

      data.detail_charger = data.charger;
      data.charger = data.contract_charger;

      if (this.data.uid.startsWith("assemble")) {
        data.assemble_date = data.schedule_date;
      } else {
        data.detail_delivery_date = data.schedule_date;
        data.delivery_date = data.contract_delivery_date;
      }
      data.detail_delivery_way_flag = data.delivery_way_flag;
      data.delivery_way_flag = data.contract_delivery_way_flag;

      delete data.addr;
      delete data.tel;
      delete data.schedule_date;
      delete data.task;
      delete data.contract_zipcode;
      delete data.contract_addr;
      delete data.contract_charger;
      delete data.contract_delivery_date;
      delete data.contract_delivery_way_flag;
      return data;
    },
    convertToServiceData(data) {
      data.customer_zipcode = data.zipcode;
      data.customer_addr = data.addr;
      data.customer_tel = data.tel;
      data.service_date = data.schedule_date;
      delete data.zipcode;
      delete data.addr;
      delete data.tel;
      delete data.schedule_date;
      delete data.task;
      return data;
    },
    handleSelectCustomer(c) {
      if (typeof c === "string") {
        this.data.customer_id = null;
        this.data.customer_name = c;
        this.data.zipcode = "";
        this.data.addr = "";
        this.data.tel = "";
        this.customer = null;
      } else {
        this.data.customer_id = c.id;
        this.data.customer_name = c.name;
        this.data.zipcode = this.util.getCustomerZipcode(c);
        this.data.addr = this.util.getCustomerAddress(c);
        this.data.tel = c.tel;
        this.customer = c;
      }
    },
    handleCompleteZipcode(zipcode, addr) {
      this.data.zipcode = zipcode;
      this.data.addr = addr;
      this.$refs.addr.focus();
    },
    handleClickRegister() {
      if (!this.has_grant_write) return;

      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.doRegister();
      });
    },
    handleClickDelete() {
      this.util.confirm_delete(this, this.title, this.doDelete);
    },
    handleReponse(res, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, message);
      this.$emit("completed", true);
    },
    handleChangeDeliveryWay() {
      let info = this.util.getAddressByDeliveryWay(
        this.data.delivery_way_flag,
        this.customer
      );
      if (!info) {
        return;
      }
      this.data.zipcode = info.zipcode;
      this.data.addr = info.addr;
    },
  },
};
</script>
